import { useEffect, useState } from "react";
import { API_URL } from "../../config";
import { authFetch } from "../../utils";

export default function ForceWaterRequest({ onCreated, waterRequests = [] }) {
  const [zones, setZones] = useState([]);
  const [selectedZoneId, setSelectedZoneId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    authFetch(`${API_URL}fwi/zones`)
      .then(r => r.json())
      .then(data => {
        const cannon = data.filter(z => z.hasCannons);
        setZones(cannon);
        if (cannon.length > 0) setSelectedZoneId(cannon[0]._id);
      })
      .catch(console.error);
  }, []);

  const handleForce = async () => {
    if (!selectedZoneId) return;
    const zone = zones.find(z => z._id === selectedZoneId);

    const automaticos = waterRequests.filter(r => r.priority >= 2);
    let msg = `¿Forzar riego de "${zone?.name}" mañana a las 6:00?`;
    if (automaticos.length > 0) {
      const nombres = automaticos.map(r => r.fwiZone?.name).filter(Boolean).join(', ');
      msg += `\n\n⚠️ Ya hay ${automaticos.length === 1 ? 'un riego automático programado' : 'riegos automáticos programados'} (${nombres}). El riego forzado tendrá prioridad sobre ${automaticos.length === 1 ? 'él' : 'ellos'}.`;
    }

    const confirmed = window.confirm(msg);
    if (!confirmed) return;

    setLoading(true);
    setError(null);
    try {
      const resp = await authFetch(`${API_URL}fwi/water-request/force`, {
        method: 'POST',
        body: JSON.stringify({ fwiZoneId: selectedZoneId }),
      });
      if (!resp.ok) {
        if (resp.status === 409) {
          alert('Ya existe un riego forzado programado para mañana. Si quieres modificar el sector a regar tienes que cancelar el existente.');
        } else {
          const text = await resp.text();
          setError(text || 'Error al programar el riego');
        }
        return;
      }
      const zone = zones.find(z => z._id === selectedZoneId);
      alert(`Riego forzado programado: mañana a las 6:00 — ${zone?.name}`);
      onCreated?.();
    } catch {
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  if (zones.length === 0) return null;

  return (
    <div style={{ marginTop: '28px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <span style={{ fontSize: '13px' }}>Forzar riego mañana a las 6:00 en </span>
      <select
        value={selectedZoneId}
        onChange={e => setSelectedZoneId(e.target.value)}
        style={{ fontSize: '13px', padding: '3px 6px', borderRadius: '4px', border: '1px solid #ccc' }}
      >
        {zones.map(z => (
          <option key={z._id} value={z._id}>{z.name}</option>
        ))}
      </select>
      <button
        onClick={handleForce}
        disabled={loading}
        style={{
          fontSize: '13px', padding: '3px 10px', cursor: 'pointer',
          backgroundColor: '#e67e22', color: 'white', border: 'none', borderRadius: '4px'
        }}
      >
        {loading ? '...' : 'Forzar'}
      </button>
      {error && <span style={{ fontSize: '12px', color: '#d9534f' }}>{error}</span>}
    </div>
  );
}
